var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell',[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"status",attrs:{"data-status":_vm.status}},[(_vm.status === 1)?_c('app-icon',{attrs:{"icon":"tickOnly"}}):_vm._e(),(!_vm.status)?_c('app-icon',{attrs:{"icon":"crossOnly"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }